import { GlobalData } from "../Common/GlobalData";
import { TemplateHelpers } from "../Common/KendoHelpers";

export class OverboughtOversoldCount {
    private static readonly GRID = '#grid';

    private dataSourceOptions!: kendo.data.DataSourceOptions;

    constructor() {
        this.init();
    }

    private init() {
        this.setDataSourceOptions();

        $(OverboughtOversoldCount.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(this.dataSourceOptions),
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            columns: [{
                field: 'tradingDate',
                title: 'Trading<br>Date',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-right' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('tradingDate')),
            }, {
                title: 'Day',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getTradingDayTemplate('tradingDate')),
            }, {
                field: 'overboughtCount',
                title: 'Overbought<br>Count',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'oversoldCount',
                title: 'Oversold<br>Count',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'nasdaqClose',
                title: 'NASDAQ<br>Close',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'nasdaq50DaySmaPct',
                title: 'NASDAQ<br>50-Day SMA%',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('nasdaq50DaySmaPct', 2)),
            }]
        });
    }

    private setDataSourceOptions() {
        this.dataSourceOptions = {
            transport: {
                read: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_OVERBOUGHT_AND_OVERSOLD_COUNT +
                    '?startDate=09-02-2020',
            },
        }
    }
}
